import { render, staticRenderFns } from "./DbcdR.vue?vue&type=template&id=dec04760"
import script from "./DbcdR.vue?vue&type=script&lang=js"
export * from "./DbcdR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports